'use client';

import type { SlackAsk } from '@/data/types';

interface SlackAsksViewProps {
  slackAsks: readonly SlackAsk[];
  onSelectMember: (id: string) => void;
  onShowToast: (message: string) => void;
}

export default function SlackAsksView({
  slackAsks,
  onSelectMember,
  onShowToast,
}: SlackAsksViewProps) {
  return (
    <div className="dashboard-view active">
      <h2 className="dash-heading">Slack Asks</h2>
      <p className="dash-subtext">
        Questions and requests caught from Slack channels. Draft responses ready
        for your review.
      </p>
      <div>
        {slackAsks.map((s, i) => (
          <div key={i} className="slack-card">
            <div className="slack-card-header">
              <span
                className="slack-member-name"
                style={{ cursor: 'pointer' }}
                onClick={() => onSelectMember(s.memberId)}
              >
                {s.member}
              </span>
              <span className="slack-channel">{s.channel}</span>
              <span className="slack-time">{s.time}</span>
            </div>
            <div className="slack-message">{s.message}</div>
            <div className="slack-draft-label">Suggested Response</div>
            <div className="slack-draft">{s.draft}</div>
            <div className="opp-actions">
              <button
                className="opp-btn primary"
                onClick={() => onShowToast(`Response sent to ${s.member}`)}
              >
                Send Response
              </button>
              <button
                className="opp-btn secondary"
                onClick={() => onShowToast('Editing draft...')}
              >
                Edit Draft
              </button>
              <button
                className="opp-btn secondary"
                onClick={() => onShowToast('Dismissed')}
              >
                Dismiss
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
